import React from "react";
import styled from "styled-components";

const InfoDiv = styled.div`
  display: block;
  font-size: 0.8em;
  border-radius: 5px;
  padding-bottom: 10px;
`;

export const Info = props => {
  return <InfoDiv className='gray-text'>{props.children}</InfoDiv>;
};



// WEBPACK FOOTER //
// ./src/components/common/form/modules/Info.tsx